import React from 'react';
import { useTranslation } from 'react-i18next';

import { PspConnector, RetryPaymentMethod, RetryPaymentStatus } from '../../../types';
import Notification from '../notification/Notification';

export type RetryPaymentDefaultProps = {
  retryPaymentUrl?: string;
  retryPaymentMethod: RetryPaymentMethod;
  retryPaymentStatus?: RetryPaymentStatus;
  orderId: string;
  connector: PspConnector;
  pspToken?: string;
  amount: number;
  currency: string;
  siteId: number;
};
const RetryPaymentDefault: React.FC<RetryPaymentDefaultProps> = ({
  retryPaymentUrl,
  retryPaymentMethod,
  retryPaymentStatus,
  orderId,
  connector,
  pspToken,
  amount,
  currency,
  siteId,
}) => {
  const { t } = useTranslation();
  //do not show the retry component when payment is already succesful or is being processed for that order
  if (retryPaymentStatus === 'SUCCESSFUL' || retryPaymentStatus === 'PROCESSING') return null;

  return (
    <Notification
      type="warning"
      id="retryPaymentNotification"
      ariaLabel={t('mzp.order.detail.retry.payment.accessibility.label')}
      linkText={t('mzp.order.detail.retry.payment.button', {
        0: t(`general.payment.${retryPaymentMethod.toLowerCase()}`),
      })}
      linkUrl={retryPaymentUrl}
      linkDataZta="retryPaymentLink"
      retryPaymentMethod={retryPaymentMethod}
      orderId={orderId}
      connector={connector}
      pspToken={pspToken}
      amount={amount}
      currency={currency}
      siteId={siteId}>
      {t('mzp.order.detail.payment.reminder.warning', {
        0: t('mzp.order.detail.retry.payment.button', {
          0: t(`general.payment.${retryPaymentMethod.toLowerCase()}`),
        }),
      })}
    </Notification>
  );
};

export default RetryPaymentDefault;
